import axios from "axios";
import constants from "../shared/constants";

const spotifyApi = axios.create({
  baseURL: constants.spotifyApiURL,
});

export default spotifyApi;
